import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Select } from "antd";
import {
  getPending,
} from "../../../../actions/micro";
import MicroPendingTable from "./MicroPendingTable";
import { getUser } from "../../../../utils/helpers";
import "./MicroPending.css";

function MicroPending() {
  const [pendingLoading, setPendingLoading] = useState(false);
  const [samples, setSamples] = useState([]);
  const [selectedTat, setSelectedTat] = useState("");
  const [selectedVisibility, setSelectedVisibility] = useState("");
  const [, setApiController] = useState(null);
  const isMounted = useRef(true);
  const user = getUser();

  const dayList = [
    { value: "All" }, // default value to show all pening results
    { value: "1-day" },
    { value: "2-day" },
    { value: "3-day" },
    { value: "5-day" },
    { value: "8-day" },
  ];
  const visibilityOptions = [
    { value: "", label: "All" },
    { value: "0", label: "Show Visible Sample" },
    { value: "1", label: "Show Hidden Sample" },
  ];

  const abortPrevApiCall = (controller) => {
    setApiController((prevController) => {
      /** cancel the last api call */
      if (prevController) {
        prevController.abort();
      }
      return controller;
    });
  };

  /**
   * Fetch the pending results
   */
  const handleFetchPending = async (tat = "", sampleVisibility = "") => {
    setPendingLoading(true);
    const controller = new AbortController();
    abortPrevApiCall(controller);
    const {
      success: pendingSuccess, message: pendingMessage, result, canceled,
    } = await getPending({ tat, view_hidden_sample: user.permissionMap.view_hidden_samples ? sampleVisibility : "0" }, controller.signal);
    if (pendingSuccess) {
      setSamples(result.map((sample, i) => ({
        ...sample, key: i,
      })));
    } else if (!canceled) {
      toast.error(pendingMessage);
      setSamples([]);
    }
    setPendingLoading(canceled);
  };

  const selectDayOption = (text) => {
    // set the payload to an empty string for all pending results
    setSelectedTat(text === "All" ? "" : text);
    handleFetchPending(text === "All" ? "" : text, selectedVisibility);
  };

  const selectVisibilityOption = (text) => {
    setSelectedVisibility(text);
    handleFetchPending(selectedTat, text);
  };

  useEffect(() => {
    handleFetchPending();
    return () => {
      isMounted.current = false;
      // when the current component is unmouted, then abort the fetch api
      abortPrevApiCall();
    };
  }, []); // eslint-disable-line

  return (
    <div className="MicroPending">
      <div className="MicroPending__DaySelect">
        <div className="dropdownSHFTContainer">
          <div className="datePickerLabel">
            Filter by Day
          </div>
          <Select
            className="MicroGenerate__Select"
            popupClassName="MicroGenerate__Select__Menu"
            options={dayList}
            defaultValue="All"
            onSelect={(text) => selectDayOption(text)}
          />
        </div>
        {user.permissionMap.view_hidden_samples && (
        <div className="dropdownSHFTContainer">
          <div className="datePickerLabel">
            Sample Visibility
          </div>
          <Select
            className="MicroGenerate__Select"
            popupClassName="MicroGenerate__Select__Menu"
            options={visibilityOptions}
            value={selectedVisibility}
            onSelect={(text) => selectVisibilityOption(text)}
          />
        </div>
        )}
      </div>
      <MicroPendingTable
        samples={samples}
        setSamples={setSamples}
        handleFetchPending={handleFetchPending}
        isPending
        migrateLoading={false}
        hideCountAndAction
        tableLoading={pendingLoading}
        selectedTat={selectedTat}
        user={user}
      />
    </div>
  );
}

export default MicroPending;
